import React, { useState, useEffect } from 'react';
import { AuthForm } from '../components/AuthForm';
import GridMotion from '../components/GridMotion';
import { imageGalleryService } from '../lib/imageGalleryService';

export const AuthPage: React.FC = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [gridItems, setGridItems] = useState<string[]>([]);


  useEffect(() => {
    const loadGridItems = async () => {
      try {
        // Test database connection first
        await imageGalleryService.testDatabaseConnection();
        
        const items = await imageGalleryService.getGridMotionItems();
        console.log('GridMotion items loaded:', items);
        console.log('Number of items:', items.length);
        console.log('First few items:', items.slice(0, 5));
        setGridItems(items);
            } catch (error) {
        console.error('Error loading grid items:', error);
        // Fallback to default items
        setGridItems([]);
      }
    };

    loadGridItems();
  }, []);

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* GridMotion Background */}
      <div className="absolute inset-0 z-0">
        <GridMotion 
          items={gridItems} 
          gradientColor="rgba(59, 130, 246, 0.1)" 
        />
      </div>
      
      {/* Overlay for better readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40 z-10"></div>
      
      {/* Auth Content */}
      <div className="relative z-20 min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center mb-6">
            <img 
              src="/assets/renovirai-logo.png" 
              alt="RenovirAI" 
              className="h-16 w-auto drop-shadow-lg"
            />
          </div>
          <h1 className="text-center text-3xl font-extrabold text-white mb-8 drop-shadow-lg">
            Welcome to RenovirAI
          </h1>
          <p className="text-center text-gray-200 mb-8 drop-shadow-lg">
            Your AI-powered renovation assistant. Sign in to get started with your next project.
          </p>
        </div>
        
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <AuthForm 
            isSignUp={isSignUp} 
            onToggleMode={() => setIsSignUp(!isSignUp)} 
          />
        </div>
      </div>
    </div>
  );
}; 